import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';

import Loading from 'app/components/loaders/Loading';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    container: {
        flexGrow: 1,
        position: 'relative',
    },
    popper: {
        right: 0,
        zIndex: 20000
    },
    paper: {
        maxHeight: '400px',
        overflowY: 'scroll'
    },
    list: {
        width: '100%',
    },
    noResults: {
        padding: theme.spacing(3),
    }

}));

export default function SearchUsersAutoComplete(props) {

    const { closeOnSelect, clearOnSelect, setOnSelect, onSelect, label, user, groupId = 0, error, disabled, admin } = props;
    const classes = useStyles();
    const api = useApi();

    const [ searchValue, setSearchValue ] = useState("");
    const [ results, setResults ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ anchorEl, setAnchorEl] = useState(null);

    const handleSearchValue = event => {
        const searchValue = event.target.value;
        setSearchValue(searchValue);
        getResults(searchValue);
    };

    const openResults = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const closeResults = () => {
        setAnchorEl(null)
    }

    const getResults = searchValue => {

        const sv = searchValue;

        if (sv.length > 2) {

            setLoading(true);

            api.get('/search/user/' + groupId + '/' + sv)
                .then(res => setResults(res.results))
                .finally(() => setLoading(false));
        } else {
            setResults([]);
        }
    }

    const handleSelect = value => {
        if (closeOnSelect) closeResults();

        if (clearOnSelect) setSearchValue("");

        if (setOnSelect) setSearchValue(value.full_name);

        onSelect(value);
    }

    const open = Boolean(anchorEl);

    return (
        <ClickAwayListener onClickAway={closeResults}>
            <div className={classes.container}>
                <TextField
                    id="search-input"
                    label={label}
                    type="search"
                    variant="outlined"
                    onChange={handleSearchValue}
                    onFocus={openResults}
                    placeholder={user ?? null}
                    value={searchValue}
                    fullWidth
                    autoComplete="off"
                    error={error}
                    disabled={disabled}
                />
                <Popper
                    transition
                    open={open}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    disablePortal={true}
                    className={classes.popper}
                    modifiers={{
                        flip: {
                            enabled: true
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'scrollParent',
                        },
                    }}
                    >
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps}>
                            <Paper className={classes.paper} square elevation={4}>
                                { (results.length > 0) ? (
                                    <div>
                                        <Loading isLoading={loading} size={40} thickness={2.8}/>
                                        <List dense className={classes.list}>
                                            {results.map(value => (
                                                <ListItem
                                                    key={value.id}
                                                    button
                                                    onClick={() => handleSelect(value)}
                                                    >
                                                    <ListItemText
                                                        primary={value.full_name}
                                                        secondary={admin ? value.membership_title : null}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div>
                                ) : (
                                    <div className={classes.noResults}>
                                        <Typography variant="subtitle1">No Results Found</Typography>
                                    </div>
                                )}
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            </div>
        </ClickAwayListener>
    );
}
